import type { Tour } from '#domain/Tour.ts';

export const formatTourSidebarName = (tour: Tour): string | undefined => {
    if (tour.firstStop?.name && tour.lastStop?.name && tour.searchName) {
        return `"${tour.searchName} (${tour.firstStop.name} -> ${tour.lastStop.name})"`;
    }
};
